import * as React from 'react';

export const useClickOutside = (
    ref: React.RefObject<HTMLElement>,
    onClickOutside: () => void,
    shouldAddListener: boolean = true,
) => {
    const clickOutsidePicker = React.useCallback(
        (e) => {
            if (ref && ref.current && !ref.current.contains(e.target)) {
                onClickOutside();
            }
        },
        [ref, onClickOutside],
    );

    React.useEffect(() => {
        if (shouldAddListener) {
            document.addEventListener('click', clickOutsidePicker);
        }

        return () => {
            document.removeEventListener('click', clickOutsidePicker);
        };
    }, [shouldAddListener, clickOutsidePicker]);
};
